import React from 'react';
import Footer from '../components/Footer.js';
import Navbar from '../components/navbar/Navbar.js';
import Sanitary from '../components/ispf/Sanitary.js';
import Banner from '../components/Banner.js';
import ispf from '../images/pics/ISPF.webp';
import { useSEO } from '../components/CustomHook';

const ISPF = () => {
    useSEO(
        "Sanierungsfahrplan (ISPF) - Individuelle Energieberatung & Sanierungsplan",
        "Erstellen Sie Ihren individuellen Sanierungsfahrplan (ISPF) mit professioneller Energieberatung. Schritt-für-Schritt zur Energiewende mit detailliertem Sanierungsplan.",
        "Sanierungsfahrplan, ISPF, Energieberatung, Sanierungsplan, Energiewende, Gebäudesanierung, Energieeffizienz",
        "/images/pics/ISPF.webp"
    );

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={ispf}
                title="Sanierungsfahrplan (ISPF)"
                subtitle="Ihr individueller Weg zur Energiewende"
                description="Erstellen Sie Ihren persönlichen Sanierungsfahrplan mit professioneller Energieberatung. Wir zeigen Ihnen Schritt für Schritt, wie Sie Ihr Gebäude energieeffizient sanieren können."
            />
            <Sanitary />
            <Footer />
        </>
    )
}

export default ISPF;

